<app-loader-spinner [isLoading]="isLoading()"></app-loader-spinner>
<p-dialog
    [(visible)]="visible"
    (onHide)="onClose()"
    [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '33vw' }"
    [header]="'Asignación de Solicitudes'"
    [draggable]="false"
    [closable]="true"
>
    <ng-template pTemplate="content">
        <div class="grid">
            <!-- Columna izquierda con scroll solo en pantallas medianas y grandes -->
            <div class="col-12 md:col-5">
                <div class="text-900 font-semibold mb-4">Solicitudes a Asignar
                    ({{ selectedCount() }})
                </div>
                <div style="max-height: 25vh; overflow-y: auto;">
                    <div *ngFor="let proyecto of selectedProyectos()"
                            class="flex align-items-center gap-2 mb-2">
                        <i class="pi pi-check-circle text-green-400 text-lg"></i>
                        <div class="flex flex-column">
                            <span>Número de expediente</span>
                            <span
                                class="text-900 font-bold">{{ proyecto.numeroExpediente }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 md:col-7">
                <div class="flex flex-column">
                    <label class="text-900 font-semibold">Asignar Empleado</label>
                    <p-dropdown #tecnicoCliente id="tecnicoCliente" [options]="users()" [(ngModel)]="tecnicosAsignados"
                                optionLabel="nombreCompleto" [showClear]="true" [filter]="true"
                                placeholder="Seleccione el empleado" appendTo="body" class="dropdown-full-width" styleClass="mt-3" [filterBy]="'nombreCompleto,usuario,rol'">
                        <ng-template let-usuario pTemplate="item">
                            <div class="flex flex-column">
                                <span class="font-medium text-900">{{ usuario.nombreCompleto }}</span>
                                <div class="flex mt-2">
                                    <p-tag styleClass="text-xs" icon="pi pi-user" [value]="usuario.rol"/>
                                    <i class="pi pi-inbox p-1 ml-2" style="font-size:1rem; color:green !important;">
                                        <span class="p-1" style="color:dimgray !important;">
                                            {{ usuario.usuario }}
                                        </span>
                                    </i>
                                </div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
            </div>
        </div>

    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="onClose()"></button>
        <button pButton pRipple type="submit" icon="pi pi-check" class="p-button-text" label="Guardar cambios" (click)="procesarAsignacion(true)"></button>
    </ng-template>
</p-dialog>
